const initialState = {
  id: null,
  iepResponsibleUsers: [],
  version: null,
  modifiedBy: null,
  modifiedAt: null,
};

export default initialState;
